import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cuentas-pendientes',
  templateUrl: './cuentas-pendientes.component.html',
  styleUrls: ['./cuentas-pendientes.component.scss'],
  providers: [DatePipe]
})
export class CuentasPendientesComponent implements OnInit {

  ahora: Date;
  metodoPagoSeleccionado = 3;
  pantallaPago = 0;
  metodosPago = [{label:'Transferencia bancaria', value: 2}, {label:'Pago electrónico (Tarjetas débito/ crédito)', value:3}];

  constructor(private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.ahora = new Date();
  }

  adelante(){
    this.pantallaPago++;
  }

  atras(){
    this.pantallaPago--;
  }

  imprimirPantalla(){
    window.print();
  }

}
